export enum SetLiveQueueType {
    SET_LIVE_QUEUE = 'SET_LIVE_QUEUE',
}